import styled from 'styled-components';

export const Container = styled.div``;

export const Label = styled.div`
  text-align: left;
  font-family: 'AvenirNext';
  font-size: 10px;
  font-weight: 500;
  color: #96979a;
  margin-bottom: 5px;
`;

export const ImageReview = styled.div`
  width: 100px;
  margin: auto;
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

export const FileName = styled.div`
  font-family: AvenirNext;
  font-size: 12px;
  color: #3b3b3b;
  margin: 10px 20px 0;
`;

export const Row_1 = styled.div`
    display: flex;
    align-items: flex-end;
`;

export default {
  Panel: {},
  Row: {
    margin: '0 0 10px',
    alignItems: 'center'
  },
  Col: {
    padding: '0 10px'
  },
  cropperModal: {
    width: 500
  }
}
